import Select from 'components/Common/Form/Input/Select'
import useTrackExperienceOfferEvent from 'contexts/support/useTrackExperienceOfferEvent'
import { useCallback, useMemo } from 'react'
import * as React from 'react'
import { useIntl } from 'react-intl'
interface Props {
  ticketModeField: App.TicketModeField
  selectedOptions: Record<string, string>
  onOptionSelect: (data: Record<string, string | undefined>) => void
  key: string
}

/** Recursive function to get the default values of all field nesting and clean up the non-selected fields */
const getChainedValues = (data: Record<string, string | undefined>, field: App.TicketModeField, selectedKey?: string) => {
  let newData = { ...data }
  newData[field.key] = selectedKey

  field.options.forEach(option => {
    const isSelected = option.key === selectedKey
    option.fields?.forEach(childField => {
      newData = { ...getChainedValues(newData, childField, isSelected ? childField.default : undefined) }
    })
  })
  return newData
}

function ExperienceTicketModeItemSelect(props: Props) {
  const { ticketModeField, onOptionSelect, selectedOptions } = props

  const trackEvent = useTrackExperienceOfferEvent()
  const intl = useIntl()

  const selectedOption = useMemo(() => (
    ticketModeField.options.find(option => option.key === selectedOptions[ticketModeField.key])
  ),
  [selectedOptions, ticketModeField])

  const handleChange = useCallback((event: React.ChangeEvent<HTMLSelectElement>) => {
    const ticketModeKey = event.target.value
    const data = getChainedValues(selectedOptions, ticketModeField, ticketModeKey)

    onOptionSelect(data)

    trackEvent('TICKET_MODE_SELECTED')
  }, [onOptionSelect, selectedOptions, ticketModeField, trackEvent])

  const handleChildrenChange = useCallback((data: Record<string, string | undefined>) => {
    if (!selectedOption) return
    onOptionSelect({ ...selectedOptions, ...data })
  }, [onOptionSelect, selectedOptions, selectedOption])

  return <>
    <Select
      required={ticketModeField.required}
      label={ticketModeField.text}
      noValidationSpacing
      name={ticketModeField.key}
      onChange={handleChange}
      placeholder={intl.formatMessage({
        id: 'L1Mvlpqkn6BDNOJm5N2-',
        defaultMessage: 'Select an option',
      })}
      value={selectedOptions[ticketModeField.key] ?? ''}
    >
      {!ticketModeField.required && <option key="none" value="">{intl.formatMessage({
        id: 'GpLhT1QhJMLSkP7jDpLJ',
        defaultMessage: '-',
      })}
      </option>}
      {ticketModeField.options.map(option => <option key={option.key} value={option.key}>{option.text}</option>)}
    </Select>

    {selectedOption?.fields?.map(field => (
      <ExperienceTicketModeItemSelect
        key={selectedOption.key + '-' + field.key}
        ticketModeField={field}
        selectedOptions={selectedOptions}
        onOptionSelect={handleChildrenChange}
      />
    ))}
  </>
}

export default ExperienceTicketModeItemSelect
